function models() {
    const page = document.querySelector('[data-model-page]');

    if (!page) {
        return;
    }

    const intro = page.querySelector('[data-model-intro]');
    const reveals = Array.from(page.querySelectorAll('[data-model-reveal]'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const filters = page.querySelector('[data-model-filters]');
    if (filters) {
        const grid = page.querySelector('[data-model-grid]');
        const items = Array.from(page.querySelectorAll('[data-model-item]'));
        const search = filters.querySelector('[data-model-search]');
        const provider = filters.querySelector('[data-model-provider]');
        const input = filters.querySelector('[data-model-input]');
        const sort = filters.querySelector('[data-model-sort]');
        const count = filters.querySelector('[data-model-count]');
        const empty = page.querySelector('[data-model-empty]');
        const update = () => {
            const query = search.value.toLowerCase().trim();
            let visible = 0;
            items.forEach((item) => {
                const matchesSearch = !query || `${item.dataset.title} ${item.dataset.provider}`.includes(query);
                const matchesProvider = !provider.value || item.dataset.provider === provider.value;
                const matchesInput = !input.value || item.dataset.input === input.value;
                item.hidden = !(matchesSearch && matchesProvider && matchesInput);
                if (!item.hidden) visible += 1;
            });
            const sorted = items.slice().sort((left, right) => {
                if (sort.value === 'title') return left.dataset.title.localeCompare(right.dataset.title);
                if (sort.value === 'cost') {
                    const leftCost = left.dataset.cost === '' ? Number.POSITIVE_INFINITY : Number(left.dataset.cost);
                    const rightCost = right.dataset.cost === '' ? Number.POSITIVE_INFINITY : Number(right.dataset.cost);
                    return leftCost - rightCost || left.dataset.title.localeCompare(right.dataset.title);
                }
                return Number(left.dataset.order) - Number(right.dataset.order);
            });
            sorted.forEach((item) => grid.insertBefore(item, empty));
            count.textContent = `${visible} model${visible === 1 ? '' : 's'}`;
            empty.hidden = visible !== 0;
        };

        const initialQuery = new URLSearchParams(window.location.search).get('q');
        if (initialQuery) search.value = initialQuery;

        [search, provider, input, sort].forEach((control) => control.addEventListener(control === search ? 'input' : 'change', update));
        update();
    }

    if (reducedMotion) {
        if (intro) intro.classList.add('is-visible');
        reveals.forEach((item) => item.classList.add('is-visible'));
        return;
    }

    page.classList.add('is-motion-ready');
    window.requestAnimationFrame(() => {
        if (intro) intro.classList.add('is-visible');
    });

    const observer = new IntersectionObserver((entries, currentObserver) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
        });
    }, {rootMargin: '0px 0px -8% 0px', threshold: 0.08});

    reveals.forEach((item) => observer.observe(item));
}

export {models};
